import React, { Suspense, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useCurrentAdminPage, useIsMobile } from "@hooks";
import useAppStore from "../../stores/appStore";
import {
  isAdminSelector, setPageNameSelector
} from "../../stores/selectors/appSelectors";
import ErrorBoundary from "../ErrorBoundries";
import { AppWrapper, ContentWrapper } from "../LayoutWrappers";
import NavigationBar from "../Navigation/NavigationBar";
import useNavigationProps from "../Navigation/NavigationBar.hook";
import { NAVIGATION_MODES } from "src/layout/Navigation/NavigationBar.consts";
import { ACCOUNT_SETTINGS, DATA_MAPPING } from "@consts";
import { useTheme, Stack } from "@mui/material";
import AdminHeader from "../Content/AdminHeader";
import OutletWithErrorHandling from "../OutletWithErrorHandling";

const AdminLayout = () => {
  const theme = useTheme();
  const location = useLocation();
  const setPageName = useAppStore(setPageNameSelector);
  const isAdmin = useAppStore(isAdminSelector);
  const isMobile = useIsMobile();
  const navigationProps = useNavigationProps(NAVIGATION_MODES.ADMIN);
  const pageName = location.pathname.split("/")?.[3];
  const displayGreyBackground = pageName === DATA_MAPPING || pageName === ACCOUNT_SETTINGS;
  const hideTitle = pageName === ACCOUNT_SETTINGS;

  useEffect(() => {
    setPageName(location.pathname.split("/")?.[2]);
  }, [location, setPageName]);

  if (!isAdmin) return <Navigate to="/403" replace />;
  return (
    <div style={{ display: "flex" }}>
      {!isMobile && (
        <NavigationBar
          {...navigationProps}
          useCurrentPage={useCurrentAdminPage}
        />
      )}
      <Suspense>
        <AppWrapper className="app" sx={{ backgroundColor: displayGreyBackground ? theme.palette.grey[50] : "#FFFFFF" }} statusBarDisplayed={navigationProps.showStatusBar}>
          <ContentWrapper component="main">
            <ErrorBoundary key={location.pathname}>
              <Stack style={{ flexGrow: 1 }}>
                {hideTitle ? null : <AdminHeader {...navigationProps} />}
                <OutletWithErrorHandling />
              </Stack>
            </ErrorBoundary>
          </ContentWrapper>
        </AppWrapper>
      </Suspense>
    </div>
  );
};

export default AdminLayout;
